import Vue3Toastify, { toast, Slide } from 'vue3-toastify'

import 'vue3-toastify/dist/index.css'
import '@/assets/scss/toast.scss'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vue3Toastify, {
    transition: Slide,
    autoClose: 4000,
    closeOnClick: true,
    position: 'top-center',
    limit: 3,
  })

  return {
    provide: { toast },
  }
})
